import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import UnityPlayer, { TrackedComponent } from './UnityPlayer'
import AccessibleMultipleChoiceGame from './AccessibleMultipleChoiceGame'
import { PostAnswerData, McqGameInputData } from '../../models/global.types'

interface MultipleChoiceQuestionsProps {
  accessibilityView: boolean
  multipleChoiceQuestionData: McqGameInputData | null
  onEndGame: (questionAndAnswerData: PostAnswerData[]) => Promise<void> | void
  onNewLightningModule: (level: string) => void
  onUpdateXP: (questionAndAnswerData: PostAnswerData[]) => void
  trackedComponents?: TrackedComponent[]
}

const MultipleChoiceQuestions: React.FC<MultipleChoiceQuestionsProps> = ({
  accessibilityView,
  multipleChoiceQuestionData,
  onEndGame,
  onNewLightningModule,
  onUpdateXP, // only fires when questions are answered correctly.
  trackedComponents = []
}: MultipleChoiceQuestionsProps) => {
  const [payloadToUnity, setPayloadToUnity] = useState<any>(null)
  const [gameEnded, setGameEnded] = useState<boolean>(false)
  const responsiveUnity = 'h-[90vh]'

  useEffect(() => {
    if (!accessibilityView) {
      // Update object to format needed for unity player
      let newPayload = null
      if (multipleChoiceQuestionData !== null && multipleChoiceQuestionData !== undefined) {
        newPayload = {
          level_name: multipleChoiceQuestionData.levelName,
          questions: JSON.stringify({ questions: multipleChoiceQuestionData.questions }),
          totalScore: multipleChoiceQuestionData.totalScore
        }
      }
      setPayloadToUnity(newPayload)
    }
  }, [accessibilityView, multipleChoiceQuestionData])

  const handleUnityUpdateXP = (json: string): void => {
    const answerData: PostAnswerData[] = JSON.parse(json).answers
    onUpdateXP(answerData)
  }

  const handleUnityEndGame = (json: string): void => {
    const answerData: PostAnswerData[] = JSON.parse(json).answers
    void onEndGame(answerData)
    setGameEnded(true)
  }

  if (multipleChoiceQuestionData !== null && multipleChoiceQuestionData !== undefined) {
    if (accessibilityView) {
      return <AccessibleMultipleChoiceGame onEndGame={onEndGame} onUpdateXP={onUpdateXP} questionsData={multipleChoiceQuestionData} />
    } else {
      return (
        <div className={clsx(responsiveUnity, 'flex justify-center')}>
          {!gameEnded &&
            <UnityPlayer
              onEndGame={handleUnityEndGame}
              onNewLightningModule={onNewLightningModule}
              onUpdateXP={handleUnityUpdateXP}
              payloadToUnity={payloadToUnity}
              trackedComponents={trackedComponents}
            />}
        </div>
      )
    }
  } else {
    return null
  }
}

export default React.memo(MultipleChoiceQuestions)
